var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, listing_index, isSpecHome } = options; 
__p+='\n\n<div class="listing-'+
((__t=( listing_index ))==null?'':__t)+
' listing-card-compact other-plans-card js-tracking" data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-status="'+
((__t=( property.status ))==null?'':__t)+
'" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'">\n  <div class="js-component_property-card border-radius js-quick-view" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'">\n  <a href="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" class="bm-link-overlay" target="_blank"></a>\n\n  ';

  let photo_class = '';
  if (!property.photo_url) { photo_class = "photo-not-available-480w"};
  
__p+='\n\n  <div class="data-wrap"\n    id="'+
((__t=( listing_index + 1 ))==null?'':__t)+
'"\n    data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'"\n    data-page="SRPLIST"\n    data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'"\n    data-status="'+
((__t=( property.status ))==null?'':__t)+
'"\n    data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'"\n    data-price="'+
((__t=( property.price ))==null?'':__t)+
'"\n    data-baths_full="'+
((__t=( property.baths_full))==null?'':__t)+
'"\n    data-baths_half="'+
((__t=( property.baths_half ))==null?'':__t)+
'"\n    data-baths="'+
((__t=( property.baths ))==null?'':__t)+
'">\n  </div>\n\n  <div class="aspect-content compact-card-image-wrapper '+
((__t=( photo_class ))==null?'':__t)+
'">\n    ';
 if (property.photo_url){ 
__p+='\n      ';
 if (listing_index <= 5){
__p+='\n        <img src="" data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="compact-card-image" alt="'+
((__t=( property.address_display ))==null?'':__t)+
'">\n      ';
 } else { 
__p+='\n        <img src="" data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="owl-lazy compact-card-image" alt="'+
((__t=( property.address_display ))==null?'':__t)+
'">\n      ';
 } 
__p+='\n    ';
 } else { 
__p+='\n      <div class="image-placeholder"></div>\n    ';
 } 
__p+='\n    <div class="compact-card-price">\n      ';
 if (!isSpecHome) {
__p+='\n        <span class="compact-card-plan-number">'+
((__t=( property.address_display ))==null?'':__t)+
'</span>\n      ';
 } 
__p+='  \n      <br />\n      '+
((__t=( property.price_display ))==null?'':__t)+
'\n    </div>\n  </div>\n  <div class="compact-card-content">\n    <div class="compact-card-address">\n      <span itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">\n        ';
 if(isSpecHome) { 
__p+='\n          <span itemprop="streetAddress">'+
((__t=( property.address_display ))==null?'':__t)+
'</span>\n        ';
 } else if (MOVE_DATA.adobeDTM.listingAddress) { 
__p+='\n          <span itemprop="streetAddress">'+
((__t=( MOVE_DATA.adobeDTM.listingAddress ))==null?'':__t)+
'</span>\n        ';
 } else { 
__p+='\n          <span itemprop="streetAddress">Address Not Available</span>\n        ';
 } 
__p+='\n      </span>\n    </div>\n    <div class="compact-card-meta ellipsis">\n        ';
 if (((property.beds_display) || (property.baths_display)) || (property.sqft_display)){ 
__p+='\n          <ul class="list-horizontal list-style-disc">\n            ';
 if (property.beds_display){ 
__p+='\n              <li data-label="compact-meta-beds">'+
((__t=( property.beds_display ))==null?'':__t)+
''+
((__t=( " bed" ))==null?'':__t)+
'</li>\n            ';
 } 
__p+='\n            ';
 if (property.baths_display){ 
__p+='\n              <li data-label="compact-meta-baths">'+
((__t=( property.baths_display ))==null?'':__t)+
''+
((__t=( " bath" ))==null?'':__t)+
'</li>\n            ';
 } 
__p+='\n            ';
 if (property.sqft){ 
__p+='\n              <li class="compact-meta-sqft " data-label="property-meta-sqft">'+
((__t=( property.sqft_display ))==null?'':__t)+
''+
((__t=( " sqft" ))==null?'':__t)+
'</li>\n            ';
 } 
__p+='\n          </ul>\n        ';
 } 
__p+='\n    </div>\n  </div>\n</div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/other-plans/other-plans-card.jst.ejs